import React from 'react'
import { Button, Card, CardBody, Tooltip, Input } from 'reactstrap';
import { useBrands } from '../../../hooks/analytes/useBrands';
import { ModalBrand } from '../../../components/brands/ModalBrand';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexBrands = () => {

    const {
        brands, method, validaciones,
        name,
        handleInputChange, loading,
        toggle, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete, handleSearch

    } = useBrands();

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };


    return (
        <>
            <Card>
                <CardBody className="p-1">
                    <div className="ribbon ribbon-clip ribbon-primary">
                        Listado de marcas
                    </div>
                    <div className="text-right" style={{ margin: 5, padding: 0 }}>
                        {/* <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={handleCreate}><span className="fa fa-plus-circle"></span></Button> */}
                    </div>
                    <div className="row">
                        <div className="offset-8 col-4 pt-1 pb-2">
                            <Input placeholder='Busqueda...' className='form-control' onChange={handleSearch} />
                        </div>
                    </div>
                    <div className="table-responsive">
                        {/* <TableStriped
                            notMaped={["visibleTable"]}
                            methodsActions={false}
                            cabeceras={["Nombre"]}
                            items={brands}
                            {...{ handleUpdate, handleDelete }}
                            nextPage={nextPage}
                            previousPage={previousPage}
                            totalPageCount={totalPageCount}
                            currentPage={currentPage}
                            goToPage={goToPage}
                        /> */}

                        <DataTable
                            value={brands}
                            paginator 
                            rows={10} 
                            className="data-table p-datatable-striped p-datatable-sm"
                            emptyMessage={
                                <div className="text-center">
                                    <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                    Sin cotizaciones.
                                    </p>
                                </div>
                                }
                            // loading={loadingQuoterFilter}
                            rowsPerPageOptions={[10, 50, 100]}
                            responsiveLayout="scroll"


                        >
                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle}/>
                           

                        </DataTable>

                    </div>
                </CardBody>
            </Card>
            <ModalBrand
                {
                ...{
                    modal, modalTitle, toggle, method,
                    validaciones,
                    name,
                    handleInputChange, loading,
                    saveCreate, saveUpdate, saveDelete
                }
                }
            />
        </>
    )
}
